import { JourneyConnected } from "../JourneyNewView/Journey"
import s from "./styles.module.scss"

type SingleJourneyViewProps = { journeyId: string }
export const SingleJourneyViewConnected = ({
  journeyId,
}: SingleJourneyViewProps) => {
  return (
    <div className={s.view}>
      <div className={s.view__journey}>
        <JourneyConnected journeyId={journeyId} />
      </div>
    </div>
  )
}
